import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import CustomTextField from "../GRI308/CustomTextField";
import SectionHeading from "../GRI308/SectionHeading";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI304_3 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    habitatStatus: "",
    habitatPartnerships: "",
    habitatAreaStatus: "",
    habitatDataMethodologies: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?Id=${id}&type=GRI300`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI300?.habitatsProtected || {};
        setFormData({
          habitatStatus: data.habitatStatus || "",
          habitatPartnerships: data.habitatPartnerships || "",
          habitatAreaStatus: data.habitatAreaStatus || "",
          habitatDataMethodologies: data.habitatDataMethodologies || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData

    if (!formData.habitatStatus) {
      newErrors.habitatStatus = "This field is required";
      formIsValid = false;
    }

    if (!formData.habitatPartnerships) {
      newErrors.habitatPartnerships = "This field is required";
      formIsValid = false;
    }

    if (!formData.habitatAreaStatus) {
      newErrors.habitatAreaStatus = "This field is required";
      formIsValid = false;
    }

    if (!formData.habitatDataMethodologies) {
      newErrors.habitatDataMethodologies = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return; // Validate form before submission
      const payload = {
        type: "GRI300",
        submitted304_3: true,
        habitatsProtected: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri300/304-4/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/304-4/${id}`);
    }
  };


  const renderContent = ({hide}) => (
    <>
      {!hide && <p className={styles.section_heading}>304 : Biodiversity</p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        304-3 : HABITATS PROTECTED OR RESTORED
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <SectionHeading text="a. What is the size and location of all habitat areas protected or restored, and whether the success of the restoration measure was or  is approved by independent external professionals." />
        <CustomTextField
          value={formData.habitatStatus}
          onChange={(e) => handleInputChange("habitatStatus", e.target.value)}
          placeholder={"Enter Number"}
          error={errors.habitatStatus}
          helperText={errors.habitatStatus}
          disabled={disabled}
        />

        <SectionHeading text="b. Does the organization have partnerships with third parties specifically aimed at protecting or restoring habitat areas separate from those where the organization directly oversees and implements restoration or protection measures?" />
        <CustomTextField
          value={formData.habitatPartnerships}
          onChange={(e) =>
            handleInputChange("habitatPartnerships", e.target.value)
          }
          placeholder={"Enter Text"}
          error={errors.habitatPartnerships}
          helperText={errors.habitatPartnerships}
          disabled={disabled}
        />

        <SectionHeading text="c. What is the status of each habitat area based on its condition at the close of the reporting period?" />
        <CustomTextField
          value={formData.habitatAreaStatus}
          onChange={(e) =>
            handleInputChange("habitatAreaStatus", e.target.value)
          }
          placeholder={"Enter Text"}
          error={errors.habitatAreaStatus}
          helperText={errors.habitatAreaStatus}
          disabled={disabled}
        />

        <SectionHeading text="d. What standards, methodologies, and assumptions were utilized in determining the size, location, and status of habitat areas, as well as in the implementation of protection and restoration measures?" />
        <CustomTextField
          value={formData.habitatDataMethodologies}
          onChange={(e) =>
            handleInputChange("habitatDataMethodologies", e.target.value)
          }
          placeholder={"Enter Text"}
          error={errors.habitatDataMethodologies}
          helperText={errors.habitatDataMethodologies}
          disabled={disabled}
        />

        {/* Submit Button */}
       
        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
      <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}

          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI304_3;
